<script setup>
import _cloneDeep from "lodash/cloneDeep";
import _isEqual from "lodash/isEqual";
import { twMerge } from "tailwind-merge";

const props = defineProps({
    class: String,
});
</script>

<template>
    <table :class="twMerge('w-full text-left whitespace-nowrap', props.class)">
        <slot></slot>
    </table>
</template>
